module.exports = __webpack_public_path__ + "static/finley-book-de36ed715e68326ac916c6abdcf28ad2.jpg";